import type {
  FeaturePermissionWebApiDto,
  GetFeaturePermissionsWebApiResponseDto,
} from '@zg-rentals/ts-rent-payment-client';

const FeaturePermissionModel = (data: GetFeaturePermissionsWebApiResponseDto) => {
  const featurePermissions: Record<string, Record<string, FeaturePermissionWebApiDto>> = {};
  for (const key of Object.keys(data.featurePermissions)) {
    featurePermissions[key] = data.featurePermissions[key].reduce(
      (permission, value) => ({ ...permission, [value.featureName]: value }),
      {} as Record<string, FeaturePermissionWebApiDto>,
    );
  }

  return { featurePermissions };
};

export default FeaturePermissionModel;
